import { Hidden } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentFunctionName } from '../../performanceModeManager';
import QuotesAsCards from './QuotesAsCards';
import QuotesAsTable from './QuotesAsTable';

class QuotesList extends Component {

    render() {
        console.perfLog(getCurrentFunctionName());

        let bigScreenElement = <QuotesAsTable {...this.props} />;

        if (!this.props.quotes.displayAsList)
            bigScreenElement = <QuotesAsCards {...this.props} />

        return (
            <>
                <Hidden only={['xl', 'lg', 'md']}>
                    <QuotesAsCards {...this.props} />
                </Hidden>
                <Hidden only={['sm', 'xs']}>
                    {bigScreenElement}
                </Hidden>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        quotes: state.quotes,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuotesList);
